<template lang="pug">
  notifications(
    group='custom-toast'
    :style='customToastStyle'
    position='bottom center'
    :max='1'
  )
    template(slot='body' slot-scope='props')
      .notification.row.middle.space-around(
        @click='props.close'
        :class='{error: props.item.type === "error", success: props.item.type === "success"}'
      )
        simple-svg.white-icon.check.m4-right-4(
          :filepath='props.item.type === "error" ? crossIcon : checkIcon'
          width='30px'
          height='30px'
        )
        p.message {{ props.item.text }}
</template>

<script>
import checkIcon from '@/assets/ic_check_base.svg'
import crossIcon from '@/assets/ic_cross.svg'

export default {
  data () {
    return {
      checkIcon,
      crossIcon
    }
  },
  computed: {
    customToastStyle() {
      return {
        width: 'auto',
        left: '50%',
        transform: 'translateX(-50%)'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors';

%notification {
  box-shadow: 0 2px 8px 0 $shadow-gray1;
  border-radius: 5px;
  display: flex;
  height: 50px;
  margin-bottom: 80px;
  padding: 12px 24px;
  max-width: auto;
}

.notification{
  @extend %notification;
  .success {
    background-color: $blue;
  }
  .error {
    background-color: $red;
  }
}

.success {
  @extend %notification;
  background-color: $blue;
}

.error {
  @extend %notification;
  background-color: $red;
}

.message {
  color: $white;
  font-size: 16px;
  font-weight: bold;
  max-width: auto;
}

.button {
  font-weight: bold;
}

.check {
  height: 30px;
  width: 30px;
}
</style>
